const RefundList = () => import('Views/refund/refund-list');
const RefundDetail = () => import('Views/refund/refund-detail');

export default[
  { path: '/refund-list', component: RefundList },
  { path: '/refund-detail/:id', component: RefundDetail },
];



// WEBPACK FOOTER //
// ./src/router/refund.js